import yousers from '@yola/yousersjs';
import Configuration from '../../configuration';

const configureYousersJS = () => {
  const config = Configuration.get();
  const publicApiUrl = config.getPublicApiUrl();
  yousers.setAPIRoot(publicApiUrl);
};

export default configureYousersJS;
